import React from "react";
import "./BrandLogo.css";

export default function BrandLogo() {
  return (
    <div className="logoContainer centeredFlex">
      <img src="/images/whiteLogo.svg" alt="white logo" />
      REDROSE
    </div>
  );
}
